import { Link } from "react-router-dom";
import type { OrderWithTimeline } from "../page";

interface Props {
  order: OrderWithTimeline;
}

export default function OrderItems({ order }: Props) {
  return (
    <div className="bg-[#141414] border border-white/5 rounded-2xl p-6">
      <h2 className="text-white font-bold text-sm mb-5 flex items-center gap-2" style={{ fontFamily: "'Cairo', sans-serif" }}>
        <div className="w-7 h-7 flex items-center justify-center bg-amber-400/10 rounded-lg">
          <i className="ri-box-3-line text-amber-400 text-sm"></i>
        </div>
        المنتجات
        <span className="mr-auto bg-white/5 text-gray-400 text-xs px-2.5 py-0.5 rounded-full font-normal">
          {order.items.length} {order.items.length === 1 ? "منتج" : "منتجات"}
        </span>
      </h2>

      <div className="space-y-3">
        {order.items.map((item, idx) => (
          <div
            key={idx}
            className="flex items-center gap-4 bg-[#1a1a1a] hover:bg-[#1e1e1e] rounded-xl p-3.5 transition-colors group"
          >
            {/* Image */}
            <div className="w-16 h-16 rounded-xl overflow-hidden flex-shrink-0 bg-[#222] border border-white/5">
              {item.image ? (
                <img
                  src={item.image}
                  alt={item.nameAr}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-300"
                />
              ) : (
                <div className="w-full h-full flex items-center justify-center">
                  <i className="ri-image-line text-gray-700 text-xl"></i>
                </div>
              )}
            </div>

            {/* Info */}
            <div className="flex-1 min-w-0">
              <p className="text-white text-sm font-bold truncate" style={{ fontFamily: "'Cairo', sans-serif" }}>
                {item.nameAr}
              </p>
              <div className="flex items-center gap-3 mt-1.5">
                <span className="flex items-center gap-1 text-gray-500 text-xs" style={{ fontFamily: "'Cairo', sans-serif" }}>
                  <i className="ri-stack-line text-gray-600"></i>
                  الكمية: {item.qty}
                </span>
                <span className="text-gray-700 text-xs">·</span>
                <span className="text-gray-500 text-xs" style={{ fontFamily: "'Cairo', sans-serif" }}>
                  {item.price.toLocaleString()} ر.س / قطعة
                </span>
              </div>
            </div>

            {/* Price */}
            <div className="flex-shrink-0 text-left">
              <p className="text-amber-400 font-black text-base" style={{ fontFamily: "'Cairo', sans-serif" }}>
                {(item.price * item.qty).toLocaleString()}
              </p>
              <p className="text-gray-600 text-xs text-left" style={{ fontFamily: "'Cairo', sans-serif" }}>ر.س</p>
            </div>
          </div>
        ))}
      </div>

      {/* View products link */}
      <div className="mt-4 pt-4 border-t border-white/5">
        <Link
          to="/products"
          className="flex items-center justify-center gap-2 text-gray-500 hover:text-amber-400 text-xs transition-colors cursor-pointer"
          style={{ fontFamily: "'Cairo', sans-serif" }}
        >
          <i className="ri-store-2-line"></i>
          تصفح المزيد من المنتجات
        </Link>
      </div>
    </div>
  );
}
